import { useCallback } from 'react';
import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { PROJECT_FRAGMENT } from 'graphql/fragments/project';
import { CO2_CALCULATIONS } from 'hooks/co2-calculator/useCO2Calculations';
import { PROJECT_PLAN_QUERY } from '../project-plan/useProjectPlan';

const UPDATE_PROJECT_RENOVATION_HOUSE_MUTATION = gql`
  mutation updateProjectRenovationHouse($projectId: ID!, $formData: UpdateProjectRenovationHouseInput!) {
    updateProjectRenovationHouse(projectId: $projectId, formData: $formData) {
      ...project
    }
  }
  ${PROJECT_FRAGMENT}
`;

const useUpdateProjectRenovationHouseMutation = () => {
  const [updateProjectRenovationHouseMutation] = useMutation(UPDATE_PROJECT_RENOVATION_HOUSE_MUTATION);

  const mutate = useCallback(
    async (projectId, formData) => {
      try {
        const {
          data: { updateProjectRenovationHouse: result },
        } = await updateProjectRenovationHouseMutation({
          variables: { projectId, formData: { ...formData } },
          refetchQueries: [
            { query: PROJECT_PLAN_QUERY, variables: { projectId } },
            { query: CO2_CALCULATIONS, variables: { projectId } },
          ],
          awaitRefetchQueries: true,
        });

        return result;
      } catch (error) {
        const e = error.graphQLErrors ? new Error(error.graphQLErrors.map((err) => err.message)) : error;
        e.raw = error || '';
        throw e;
      }
    },
    [updateProjectRenovationHouseMutation],
  );
  return mutate;
};

export default useUpdateProjectRenovationHouseMutation;
